import {
    QueryClient
} from "@tanstack/react-query";
import axios from "src/common/cotAxios";
import {AxiosRequestConfig} from "axios";

// 通用 axios 请求逻辑

export const queryClient= new QueryClient({
    defaultOptions:{
        queries:{
            staleTime:0,
            gcTime:0,
            retry:false,
            queryFn:async ({queryKey,signal}) => {
                // 约定 queryKey 的格式，比如 ["url", params?]
                const [url, paramsOrConfig] = queryKey;
                // 支持 GET / POST 等灵活方式
                const {
                    method = "get",
                    params,
                    data,
                    headers,
                    ...rest
                } = (paramsOrConfig || {}) as AxiosRequestConfig;

                const response = await axios({
                    url:url as string,
                    method,
                    params,
                    data,
                    headers,
                    signal,
                    ...rest
                });
                return response.data;
            }
        }
    }
});
